import type { Feature } from '../feature';
import { q } from '../../shared/dom';
import { getLang, setLang, t } from '../../shared/i18n';
import { currentUser, logout } from '../../shared/session/session';

/** Barra superior do backoffice: título da página, idioma, quem está logado e sair. */
export const topbar: Feature & { setTitle(title: string): void } = {
  template: () => `
<header class="topbar" id="topbar">
  <button class="nav-toggle" id="nav-toggle" aria-label="Menú" aria-controls="sidebar" aria-expanded="false"><span></span><span></span><span></span></button>
  <h1 class="topbar-title" id="topbar-title"></h1>
  <div class="spacer" style="flex:1"></div>
  <div class="lang" role="group" aria-label="Idioma">
    <button id="lang-es" aria-pressed="true">ES</button>
    <button id="lang-pt" aria-pressed="false">PT</button>
  </div>
  <div class="hb-who" id="topbar-who"><b id="topbar-name">—</b><span id="topbar-role">—</span></div>
  <button class="btn btn-sm btn-ghost" id="admin-logout" title="Cerrar sesión">⎋</button>
</header>`,

  mount() {
    q('#lang-es').onclick = () => setLang('es');
    q('#lang-pt').onclick = () => setLang('pt');
    q('#admin-logout').onclick = logout;
  },

  render() {
    q('#lang-es').setAttribute('aria-pressed', String(getLang() === 'es'));
    q('#lang-pt').setAttribute('aria-pressed', String(getLang() === 'pt'));
    const u = currentUser();
    q('#topbar-name').textContent = u?.name ?? '—';
    q('#topbar-role').textContent = u ? t(u.role === 'ADMIN' ? 'role.admin' : u.role === 'HOST' ? 'role.host' : 'role.support') : '—';
    q('#topbar-who').title = u?.email ?? '';
    q('#admin-logout').title = t('common.logout');
  },

  setTitle(title: string) {
    q('#topbar-title').textContent = title;
    document.title = title ? `${title} · Rueda de la Fortuna` : 'Rueda de la Fortuna';
  }
};
